const BOT_URL = "https://t.me/snimok_bot";

const ACTIONS = [
  { title: "Улучшить фото", text: "Поднять резкость и цвет, убрать шум — снимок выглядит так, будто снят на хорошую камеру." },
  { title: "Фото на документы", text: "Портрет на паспорт или визу: белый фон, правильный кадр, деловой вид." },
  { title: "Перенести объект", text: "Взять человека или предмет с одного снимка и аккуратно вписать в другой." },
  { title: "Создать картинку по описанию", text: "Опиши словами, что нарисовать — исходное фото для этого не нужно." },
];

const PACKAGES = [
  { price: "99 ₽", count: "3 генерации" },
  { price: "199 ₽", count: "10 генераций" },
  { price: "499 ₽", count: "30 генераций" },
];

/**
 * Витрина для тех, кто открыл сайт в обычном браузере, а не из бота.
 *
 * Нужна не только людям: по этому адресу сайт проверяет банк-эквайер, и сюда же ведёт
 * кнопка «В магазин» с его платёжной формы. Раньше здесь была ошибка авторизации TWA —
 * для проверяющего это выглядит как неработающий магазин.
 */
export function Landing() {
  return (
    <div style={{ minHeight: "100vh", background: "var(--color-sk-bg)", color: "var(--color-sk-text)" }}>
      <div style={{ maxWidth: 680, margin: "0 auto", padding: "56px 20px 72px" }}>
        <header>
          <h1
            style={{
              fontFamily: "var(--font-sk-display)",
              fontStyle: "italic",
              fontSize: 52,
              lineHeight: 1,
              letterSpacing: -1,
              margin: 0,
            }}
          >
            Снимок
          </h1>
          <p style={{ fontSize: 18, color: "var(--color-sk-text-mute)", margin: "14px 0 0", lineHeight: 1.5 }}>
            Обработка фотографий нейросетью прямо в Telegram. Пришли снимок — получишь готовый
            результат за минуту.
          </p>

          <a
            href={BOT_URL}
            style={{
              display: "inline-block",
              marginTop: 28,
              padding: "14px 28px",
              borderRadius: 999,
              background: "var(--color-sk-accent)",
              color: "#fff",
              fontWeight: 600,
              fontSize: 16,
              textDecoration: "none",
            }}
          >
            Открыть бота в Telegram
          </a>
        </header>

        <section style={{ marginTop: 56 }}>
          <h2 style={{ fontFamily: "var(--font-sk-display)", fontStyle: "italic", fontSize: 30, margin: "0 0 20px" }}>
            Что умеет
          </h2>
          <div style={{ display: "grid", gap: 12 }}>
            {ACTIONS.map((a) => (
              <div
                key={a.title}
                style={{
                  background: "var(--color-sk-card)",
                  border: "1px solid var(--color-sk-line)",
                  borderRadius: "var(--radius-sk-card)",
                  padding: "18px 20px",
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 6 }}>{a.title}</div>
                <div style={{ color: "var(--color-sk-text-mute)", fontSize: 15, lineHeight: 1.5 }}>{a.text}</div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ marginTop: 56 }}>
          <h2 style={{ fontFamily: "var(--font-sk-display)", fontStyle: "italic", fontSize: 30, margin: "0 0 12px" }}>
            Сколько стоит
          </h2>
          <p style={{ color: "var(--color-sk-text-mute)", fontSize: 15, lineHeight: 1.5, margin: "0 0 20px" }}>
            Первые обработки — бесплатно, каждый день. Когда бесплатные закончатся, можно купить
            пакет генераций. Они не сгорают.
          </p>

          <div style={{ display: "grid", gap: 12 }}>
            {PACKAGES.map((p) => (
              <div
                key={p.price}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "var(--color-sk-card)",
                  border: "1px solid var(--color-sk-line)",
                  borderRadius: "var(--radius-sk-card)",
                  padding: "16px 20px",
                }}
              >
                <span style={{ fontSize: 16 }}>{p.count}</span>
                <span style={{ fontFamily: "var(--font-sk-mono)", fontSize: 16, fontWeight: 600 }}>{p.price}</span>
              </div>
            ))}
          </div>
        </section>

        <section style={{ marginTop: 56 }}>
          <h2 style={{ fontFamily: "var(--font-sk-display)", fontStyle: "italic", fontSize: 30, margin: "0 0 16px" }}>
            Оплата и возврат
          </h2>
          <div style={{ color: "var(--color-sk-text-mute)", fontSize: 15, lineHeight: 1.65 }}>
            <p style={{ margin: "0 0 12px" }}>
              Оплата картой или через СБП на защищённой странице АО «ТБанк». Данные карты не
              передаются продавцу и не хранятся у него.
            </p>
            <p style={{ margin: "0 0 12px" }}>
              Генерации зачисляются на счёт сразу после оплаты. Услуга считается оказанной в момент,
              когда бот прислал обработанное фото.
            </p>
            <p style={{ margin: 0 }}>
              Если генерации оплачены, но не израсходованы, деньги за них возвращаются по запросу —
              напишите на почту ниже, укажите дату и сумму платежа. Возврат приходит на ту же карту
              в течение 10 рабочих дней. Если обработка не удалась по вине сервиса, генерация
              возвращается на счёт автоматически.
            </p>
          </div>
        </section>

        <section style={{ marginTop: 56 }}>
          <h2 style={{ fontFamily: "var(--font-sk-display)", fontStyle: "italic", fontSize: 30, margin: "0 0 16px" }}>
            Продавец
          </h2>
          <div
            style={{
              background: "var(--color-sk-card)",
              border: "1px solid var(--color-sk-line)",
              borderRadius: "var(--radius-sk-card)",
              padding: "20px",
              fontSize: 14,
              lineHeight: 1.7,
              color: "var(--color-sk-text-mute)",
            }}
          >
            <div style={{ color: "var(--color-sk-text)", fontWeight: 600, marginBottom: 8 }}>
              ИП Ярмухаметов Ильгиз Ильясович
            </div>
            <div>ИНН 026603522280</div>
            <div>ОГРНИП 325028000293501</div>
            <div>453251, Респ. Башкортостан, г. Салават, ул. Губайдуллина, д. 4, кв. 159</div>
            <div style={{ marginTop: 12 }}>
              Почта:{" "}
              <a href="mailto:ilgizilgiz@gmail.com" style={{ color: "var(--color-sk-text)" }}>
                ilgizilgiz@gmail.com
              </a>
            </div>
            <div>Телефон: +7 917 424-25-78</div>
          </div>
        </section>

        <footer style={{ marginTop: 48, fontSize: 13, color: "var(--color-sk-text-dim)" }}>
          Оплачивая пакет, вы соглашаетесь с условиями, описанными на этой странице.
        </footer>
      </div>
    </div>
  );
}
